import {
    SET_TIPOS_GRUPO_PLANES,
    SET_TIPOS_PUBLICACION, 
    FETCH_TIPOS_PUBLICACION,
    FETCH_TIPOS_PUBLICACION_BYID,
    LOADING_TIPOS_PUBLICACION
} from '../actions/types';

const initialState = {
    loadingTiposPublicacion: false,
    tiposPublicacion: {},
    tiposPublicaciones: [],
    setTiposPublicacion: {},
    tiposGruposPlanes: []
}

export default function (state = initialState, action) {

    switch (action.type) {

        case LOADING_TIPOS_PUBLICACION:
            return {
                ...state,
                loadingTiposPublicacion: action.payload
            };

        case SET_TIPOS_PUBLICACION:
            return {
                ...state,
                setTiposPublicacion: action.payload
            };

        case FETCH_TIPOS_PUBLICACION:
            return {
                ...state,
                tiposPublicaciones: action.payload.data
            };

        case FETCH_TIPOS_PUBLICACION_BYID:
            return {
                ...state,
                tiposPublicacion: action.payload.data.elementos[0]
            };

        case SET_TIPOS_GRUPO_PLANES:
            return {
                ...state,
                tiposGruposPlanes: action.payload
            };
            
        default: return state
    }
}